import { useApiDefaults } from './useApiDefaults';
import { useQuery } from '@tanstack/react-query';
import axios from 'config/axios';
import { ReactQueryKeys } from 'config/constant';
import { refetchOnWindowFocus } from 'config/reactQuery';
import { useSelector } from 'react-redux';

export function useGetRecentlyPurchaseProducts(page_name = "", is_mealkit = 0) {
  const apiDefaults = useApiDefaults();
  const isUserLoggedIn = useSelector(({ user }) => user?.isUserLoggedIn);
  const { pastOrderCheckedList } = useSelector(({ product }) => product);
  
  let orderDates = (pastOrderCheckedList ?? [])
  orderDates.sort()
  orderDates = orderDates.join("|")
  const body = {
    ...apiDefaults,
    page_name,
    is_mealkit,
    reorder_date: orderDates,
  };

  const getData = async () => {
    if (!isUserLoggedIn) {
      return {
        data: []
      };
    }

    const response = await axios.post("/AogGetRecentlyPurchaseProducts", body);
    return response?.data?.data || [];
  };

  const {
    data = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: [ReactQueryKeys.FREQUENTLY_PURCHASED_PRODUCTS, apiDefaults, page_name, is_mealkit, orderDates],
    queryFn: getData,
    refetchOnWindowFocus,
  });

  return {
    data: data?.recently_purchase || [],
    isLoading,
    error,
  };
}